export type Office = {
  id: number;
  companyId: number;
  areaId: number;
  name: string;
  kanaName: string;
  displayName: string;
  address: string;
  deletedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  linkedAt?: string;
};

export const ONLY_CONTRACT = "D";
export const PLUS_CITY = "E";

export type OfficeDivision = typeof ONLY_CONTRACT | typeof PLUS_CITY;
